import { driverMapPl } from './driverMap';
import { boltQualityPl } from './boltQuality';
import { claimsPl } from './claims';
export default {
  driverMap: driverMapPl,
  boltQuality: boltQualityPl,
  claims: claimsPl,
  nav: {
    driverMap: 'Mapa kierowców',
    dashboard: 'Dashboard',
    company: 'Firma',
    subcompanies: 'Oddziały',
    bankAccounts: 'Konta Bankowe',
    admins: 'Administratorzy',
    fleet: 'Flota',
    driverFleet: 'Flota Kierowców',
    crashes: 'Szkody',
    claims: 'Likwidacja szkód',
    fuelCards: 'Karty Paliwowe',
    inspections: 'Inspekcje',
    rentToOwn: 'Najem z wykupem',
    drivers: 'Kierowcy',
    driversArchive: 'Archiwum',
    bonuses: 'Bonusy',
    invoices: 'FV do Akceptacji',
    costInvoices: 'FV Kosztowe',
    incomes: 'Przychody',
    documentTemplates: 'Wzory Dokumentów',
    pendingDocuments: 'Oczekujące Dokumenty',
    driverOnboarding: 'Kierowcy do Akceptacji',
    pendingDriversChanges: 'Oczekujące Zmiany Kierowców',
    uploader: 'Importer',
    uploaderTemplates: 'Wzory',
    importHistory: 'Historia Importu',
    settlements: 'Rozliczenia',
    contracts: 'Zleceniówka',
    payouts: 'Wypłaty',
    dailyPayouts: 'Wypłaty dzienne',
    selfServicePayouts: 'Wypłaty BLIK',
    boltSyncDrivers: 'Synchronizacja Bolt',
    receipts: 'Rachunki',
    cashReport: 'Raport kasowy',
    assistant: 'Asystent biura',
    tasks: 'Zadania',
    notifications: 'Powiadomienia',
    notificationLogs: 'Logi Powiadomień',
    komornikLetters: 'Obsługa komornicza',
    policySales: 'Sprzedaż polis',
    payoutConfig: 'Konfiguracja Wypłat',
    wiki: 'Wiki',
    auditLogs: 'Logi Zdarzeń',
    systemSettings: 'Ustawienia systemu',
    mailConfig: 'Konfiguracja E-mail',
    appVersion: 'Wersja aplikacji',
    usageStats: 'Statystyki użycia',
    debtors: 'Lista dłużników',
    integrations: 'Integracje API',
    chat: 'Czat',
    documentsRepository: 'Repozytorium Dokumentów',
    officialDocuments: 'Dokumenty urzędowe',
    companyLicenses: 'Licencje TAXI',
    legalization: 'Legalizacja pobytu',
    marketingPosts: 'Posty i grafiki',
    announcements: 'Komunikaty',
    websiteLeads: 'Zgłoszenia ze strony',
    hr: 'Kadry',
    workTime: 'Ewidencja czasu pracy',
    sms: 'SMS',
    accounting: 'Księgowość',
    email: 'E-mail',
    wykazPojazdy: 'Wykaz Pojazdów',
    wykazKierowcy: 'Wykaz Kierowców',
    staffActivity: 'Aktywność pracowników',
    pointsSettings: 'Punkty – Ustawienia',
    pointsReferrals: 'Punkty – Polecenia',
    pointsReviews: 'Punkty – Opinie',
    pointsRewardOrders: 'Punkty – Zamówienia Nagród',
    pointsDrivers: 'Punkty – Salda Kierowców',
    subFleet: 'Podfloty',
    carRent: 'Wynajem Aut',
    skippedImport: 'Pominięte Importy',
    fleetDetails: 'Szczegóły Pojazdu',
    driverDetails: 'Szczegóły Kierowcy',
  },
  groups: {
    firma: 'Firma',
    administracja: 'Administracja',
    flota: 'Flota',
    kierowcy: 'Kierowcy',
    finanse: 'Finanse',
    dokumenty: 'Dokumenty',
    import: 'Import',
    komunikacja: 'Komunikacja',
    marketing: 'Marketing',
    wykazy: 'Wykazy',
    programPunktowy: 'Program Punktowy',
    ustawienia: 'Ustawienia',
  },
  app: {
    menuConfig: 'Konfiguracja Menu',
    accountSettings: 'Ustawienia konta',
    logout: 'WYLOGUJ',
    standalone: 'Samodzielne',
    unassignedPages: 'Nieprzypisane strony',
    standalonePages: 'Samodzielne (bez folderu)',
    dragHint: 'Przeciągnij strony tutaj...',
    standaloneDragHint: 'Przeciągnij strony tutaj — wyświetlą się bez folderu',
    newGroupLabel: 'Nazwa nowej grupy',
    iconLabel: 'Ikona',
    add: 'Dodaj',
    save: 'Zapisz',
    cancel: 'Anuluj',
    restoreDefaults: 'Przywróć domyślne',
    menuConfigTitle: 'Konfiguracja grup menu',
    searchPage: 'Szukaj strony...',
    switchCompany: 'Zmień firmę',
  },
  common: {
    save: 'Zapisz',
    cancel: 'Anuluj',
    add: 'Dodaj',
    edit: 'Edytuj',
    delete: 'Usuń',
    search: 'Szukaj',
    loading: 'Ładowanie...',
    noData: 'Brak danych',
    confirm: 'Potwierdź',
    yes: 'Tak',
    no: 'Nie',
    close: 'Zamknij',
    back: 'Wróć',
    next: 'Dalej',
    previous: 'Wstecz',
    actions: 'Akcje',
    status: 'Status',
    date: 'Data',
    name: 'Nazwa',
    description: 'Opis',
    error: 'Błąd',
    success: 'Sukces',
    warning: 'Uwaga',
    required: 'Wymagane',
    all: 'Wszyscy',
    perPage: 'Na stronę:',
    dateFrom: 'Data Od',
    dateTo: 'Data Do',
    driver: 'Kierowca',
    download: 'Pobierz',
    export: 'Eksport',
    preview: 'Podgląd',
    approve: 'Akceptuj',
    reject: 'Odrzuć',
    active: 'Aktywny',
    inactive: 'Nieaktywny',
    pending: 'Oczekujący',
    expired: 'Wygasły',
    fieldRequired: 'To pole jest wymagane',
    confirmDelete: 'Napewno usunąć?',
    refresh: 'Odśwież',
    month: 'Miesiąc',
    year: 'Rok',
    fitToWidth: 'Dopasuj do szerokości',
    addEntry: 'Dodaj wpis',
  },
  invoices: {
    title: 'Faktury',
    addButton: 'Dodaj',
    docTypeLabel: 'Typ dokumentu',
    docTypeInvoice: 'Faktura',
    docTypeConfirmation: 'Potwierdzenie',
    docTypeSaved: 'Typ dokumentu zapisany',
    acceptTitle: 'Akceptacja Faktury',
    viewTitle: 'Podgląd Faktury',
    createTitle: 'Formularz Faktury',
    driverData: 'Dane z faktury kierowcy',
    vatBreakdown: 'Podział kwot VAT',
    driverReturn: 'Zwrot dla kierowcy',
    returnPercent: 'Zwrot (%)',
    driverAmount: 'Kwota dla kierowcy',
    acceptBtn: 'Akceptuj',
    companyBtn: 'Firmowa',
    rejectBtn: 'Odrzuć',
    previousInvoice: 'Poprzednia',
    nextInvoice: 'Następna',
    noFile: 'Brak pliku do podglądu',
    downloadFile: 'Pobierz',
    csv: 'CSV',
    downloadFiles: 'Pobierz pliki',
    headers: {
      date: 'Data',
      category: 'Kategoria',
      taxRate: 'Stawka',
      brutto: 'Brutto',
      netto: 'Netto',
      vat: 'Kwota VAT',
      driverCost: 'Dla Kierowcy',
      driver: 'Kierowca',
      status: 'Status',
      file: 'Plik',
      description: 'Opis',
      driverAmount: 'Kwota od kierowcy',
      vatRateDriver: 'Stawka VAT (od kierowcy)',
    },
    statuses: {
      paid: 'Opłacona',
      payoutCreated: 'Wypłata utworzona',
      pending: 'Oczekująca',
      accepted: 'Zaakceptowana',
      company: 'Firmowa',
      rejected: 'Odrzucona',
    },
    tabs: {
      pending: 'Do akceptacji',
      accepted: 'Zaakceptowane',
      company: 'Firmowe',
      rejected: 'Odrzucone',
    },
    categories: {
      FUEL: 'Paliwo',
      CAR_PARTS: 'Części samochodowe',
      SERVICE: 'Serwis / naprawa',
      OTHER: 'Inne',
    },
    confirmReject: 'Odrzucić fakturę?',
    confirmRejectText: 'Faktura zostanie usunięta.',
    confirmCompany: 'Akceptuj jako firmową',
    confirmCompanyText: 'Faktura zostanie zaakceptowana jako firmowa — kierowca nie otrzyma zwrotu i zobaczy ją jako odrzuconą.',
    acceptedMsg: 'Faktura została zaakceptowana',
    companyMsg: 'Faktura zaakceptowana jako firmowa',
    rejectedMsg: 'Faktura została odrzucona',
    noMore: 'Brak kolejnych faktur do akceptacji.',
    confirmDelete: 'Napewno usunąć?',
    confirmCompanyBtn: 'Tak, akceptuj jako firmową',
    confirmRejectBtn: 'Tak, odrzuć',
    downloadError: 'Nie udało się pobrać pliku',
    loadError: 'Nie udało się załadować faktury',
    csvError: 'Nie udało się wyeksportować CSV',
    zipError: 'Nie udało się pobrać plików',
    genericError: 'Wystąpił błąd',
  },
  websiteLeads: {
    title: 'Zgłoszenia ze strony',
    eyebrow: 'Centrum kontaktu',
    subtitle: 'Wszystkie zapytania z btpartner.pl — uporządkowane i gotowe do szybkiej obsługi.',
    inboxLabel: 'Skrzynka kontaktowa',
    newShort: 'nowych',
    newCount: 'Nowe',
    stats: {
      today: 'Dziś',
      last7: 'Ostatnie 7 dni',
      last30: 'Ostatnie 30 dni',
      total: 'Łącznie',
      sectionLabel: 'Statystyki zgłoszeń',
      todayHint: 'napłynęło od północy',
      last7Hint: 'z ostatniego tygodnia',
      last30Hint: 'z ostatniego miesiąca',
      totalHint: 'wszystkie zapisane kontakty',
      chartTitle: 'Zgłoszenia dziennie (30 dni)',
      chartSubtitle: 'Aktywność formularza kontaktowego dzień po dniu',
      last30Short: '30 dni',
      todayShort: 'dziś',
      noChartData: 'Brak danych do wyświetlenia',
    },
    statusOverviewTitle: 'Status obsługi',
    statusOverviewSubtitle: 'Aktualny podział wszystkich zgłoszeń',
    listEyebrow: 'Bieżąca praca',
    listTitle: 'Skrzynka zgłoszeń',
    listSubtitle: 'Skontaktuj się z kandydatem, zapisz ustalenia i pilnuj kolejnego kroku.',
    filterLabel: 'Filtr statusu zgłoszeń',
    searchPlaceholder: 'Szukaj po osobie, telefonie, e-mailu lub treści…',
    resultsPrefix: 'Zgłoszeń w tym widoku:',
    searchingFor: 'Wyniki dla',
    filterNew: 'Nowe',
    filterInProgress: 'W trakcie',
    filterHandled: 'Obsłużone',
    filterAll: 'Wszystkie',
    statusNew: 'Nowe',
    statusInProgress: 'W trakcie',
    statusHandled: 'Obsłużone',
    markHandled: 'Obsłużone',
    markInProgress: 'W trakcie',
    markNew: 'Przywróć',
    showFull: 'Pokaż całą wiadomość',
    openDetails: 'Otwórz szczegóły',
    moreActions: 'Więcej działań',
    changeStatus: 'Zmień status',
    detailsEyebrow: 'Szczegóły zgłoszenia',
    messageTitle: 'Wiadomość z formularza',
    messageSubtitle: 'Pełna treść przesłana przez osobę kontaktującą się z BTP',
    noMessage: 'Nie dodano wiadomości.',
    noEmail: 'Nie podano e-maila',
    noCity: 'Nie podano miasta',
    noNote: 'Nie dodano jeszcze notatki wewnętrznej.',
    noNoteSubtitle: 'Dodaj ustalenia po kontakcie z kandydatem',
    lastHandledBy: 'Ostatnio obsługiwał',
    emptyTitle: 'Brak zgłoszeń w tym widoku',
    emptySubtitle: 'Zmień filtr lub wyczyść wyszukiwanie, aby zobaczyć pozostałe kontakty.',
    noteTitle: 'Notatka do zgłoszenia',
    noteHint: 'Co się dzieje ze zgłoszeniem — np. „dzwoniłem, oddzwoni jutro”. Pusta notatka = usunięcie.',
    noteAdd: 'Dodaj notatkę',
    noteEdit: 'Edytuj notatkę',
    deleteTitle: 'Usunąć zgłoszenie?',
    deleteText: 'Zgłoszenie zniknie bezpowrotnie.',
    translateMessage: 'Przetłumacz na polski',
    translationTitle: 'Tłumaczenie (PL)',
    translationFrom: 'z języka',
    contacts: {
      tab: 'Kontakty',
      listTitle: 'Baza kontaktów',
      listSubtitle: 'Wszystkie osoby, które się zgłosiły — lista do kontaktu na przyszłość, np. gdy zwolnią się auta.',
      resultsPrefix: 'Kontaktów w bazie:',
      leadsHeader: 'Zgłoszenia',
      lastLeadHeader: 'Ostatnie zgłoszenie',
      smsAction: 'SMS',
      emailAction: 'E-mail',
      exportCsv: 'Eksport CSV',
      emptyTitle: 'Brak kontaktów w bazie',
      emptySubtitle: 'Kontakty pojawią się tu automatycznie po pierwszym zgłoszeniu ze strony.',
      bulk: {
        selected: 'Zaznaczono:',
        smsBtn: 'SMS do zaznaczonych',
        emailBtn: 'E-mail do zaznaczonych',
        clear: 'Wyczyść zaznaczenie',
        title: 'Wysyłka zbiorcza',
        recipients: 'Odbiorcy',
        skippedEmail: 'Pominięci (brak e-maila): {n}',
        skippedPhone: 'Pominięci (brak telefonu): {n}',
        sent: 'Wysłano do {n} odbiorców',
        partial: 'Wysłano {n} z {total}',
        failedList: 'Nie udało się wysłać do:',
      },
    },
    reply: {
      smsAction: 'Odpowiedz SMS',
      emailAction: 'Odpowiedz e-mail',
      title: 'Odpowiedź na zgłoszenie',
      channelLabel: 'Kanał',
      langLabel: 'Język wysyłki',
      langPl: 'Polski',
      langEn: 'Angielski',
      langUk: 'Ukraiński',
      langRu: 'Rosyjski',
      langKa: 'Gruziński',
      subjectLabel: 'Temat e-maila',
      subjectPlaceholder: 'BTP Partner — odpowiedź na Twoje zgłoszenie',
      textLabel: 'Treść — pisz po polsku',
      textPlaceholder: 'Napisz odpowiedź po polsku…',
      translateBtn: 'Przetłumacz',
      translatedLabel: 'Zostanie wysłane (możesz poprawić)',
      needTranslate: 'Przetłumacz treść przed wysyłką',
      send: 'Wyślij',
      sent: 'Odpowiedź wysłana',
      historyTitle: 'Wysłane odpowiedzi',
      historySubtitle: 'Historia korespondencji z tym zgłoszeniem',
      historyEmpty: 'Nie wysłano jeszcze odpowiedzi.',
      original: 'Oryginał (PL)',
      failed: 'Nie wysłano',
      templateLabel: 'Szablon odpowiedzi',
      templatePlaceholder: '— wybierz szablon —',
      templateSave: 'Zapisz jako szablon',
      templateSaveTitle: 'Nazwa szablonu',
      templateSaveHint: 'np. „Brak aut w mieście”',
      templateSaved: 'Szablon zapisany',
      templateDelete: 'Usuń wybrany szablon',
      templateDeleteTitle: 'Usunąć szablon?',
      templateDeleteText: 'Szablon zniknie dla całego biura.',
      tooLong: 'Za długi SMS — skróć treść (limit: 918 znaków bez znaków specjalnych, ~400 z nimi)',
      unicodeBecause: 'znaki spoza GSM:',
    },
    headers: {
      createdAt: 'Data',
      name: 'Imię i nazwisko',
      phone: 'Telefon',
      email: 'E-mail',
      city: 'Miasto',
      message: 'Wiadomość',
      note: 'Notatka',
      status: 'Status',
      lead: 'Zgłoszenie',
      contact: 'Kontakt',
      actions: 'Działania',
    },
  },
  announcements: {
    title: 'Komunikaty',
    addButton: 'Dodaj komunikat',
    editTitle: 'Edytuj komunikat',
    newTitle: 'Nowy komunikat',
    contentLabel: 'Treść komunikatu *',
    expiresDateLabel: 'Ważny do — data (opcjonalnie)',
    expiresTimeLabel: 'Godzina',
    sendToAll: 'Wyślij do wszystkich',
    subCompaniesLabel: 'Oddziały *',
    limitedAccess: 'Masz dostęp tylko do przypisanych oddziałów',
    titleLabel: 'Tytuł (widoczny tylko w panelu admina)',
    headers: {
      title: 'Tytuł',
      content: 'Treść',
      createdAt: 'Data dodania',
      expiresAt: 'Ważny do',
      targets: 'Widoczność',
      status: 'Status',
      author: 'Autor',
    },
    statusActive: 'Aktywny',
    statusExpired: 'Wygasły',
    noExpiry: 'Bezterminowy',
    allTargets: 'Wszyscy',
    confirmDelete: 'Usunąć komunikat?',
  },
  driverOnboarding: {
    title: 'Kierowcy do Akceptacji',
    searchPlaceholder: 'Szukaj...',
    perPage: 'Na stronę:',
    pageText: '{0}-{1} z {2}',
    loadingText: 'Ładowanie...',
    noDataText: 'Brak kierowców do akceptacji',
    preview: 'Podgląd',
    accept: 'Akceptuj',
    reject: 'Odrzuć',
    acceptDriver: 'Akceptuj Kierowcę',
    rejectDriver: 'Odrzuć Kierowcę',
    tabs: {
      personalData: 'Dane osobowe',
      documents: 'Dokumenty',
      zus: 'ZUS',
      consents: 'Zgody',
    },
    editData: 'Edytuj dane',
    contactData: 'Dane kontaktowe',
    basicData: 'Dane podstawowe',
    address: 'Adres',
    registration: 'Rejestracja',
    onboardingStatus: 'Status onboardingu',
    labels: {
      email: 'Email',
      phone: 'Telefon',
      emailVerified: 'Email zweryfikowany',
      phoneVerified: 'Telefon zweryfikowany',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      citizenship: 'Obywatelstwo',
      language: 'Język',
      dateOfBirth: 'Data urodzenia',
      ownVehicle: 'Własny pojazd',
      vehicleMake: 'Marka',
      vehicleModel: 'Model',
      vehicleYear: 'Rok produkcji',
      vehiclePlate: 'Nr rejestracyjny',
      hasBusiness: 'Działalność',
      registerType: 'Sposób rejestracji',
      referralCode: 'Kod polecający',
      bankAccount: 'Nr konta bankowego',
      payoutType: 'Typ wypłaty',
      street: 'Ulica',
      homeNumber: 'Nr domu',
      aptNumber: 'Nr mieszkania',
      postalCode: 'Kod pocztowy',
      city: 'Miasto',
      registrationDate: 'Data rejestracji',
      status: 'Status',
      assignedCompany: 'Przypisana firma',
      businessActivity: 'Działalność gospodarcza',
    },
    yes: 'Tak',
    no: 'Nie',
    none: 'Brak',
    addDocument: 'Dodaj dokument',
    noDocuments: 'Brak przesłanych dokumentów',
    file: 'Plik',
    validUntil: 'Ważny do',
    rejectionReason: 'Powód odrzucenia',
    editZus: 'Edytuj ZUS',
    addZus: 'Dodaj ZUS',
    noZusDeclarations: 'Brak oświadczeń ZUS',
    zus: {
      employedElsewhere: 'Zatrudniony gdzie indziej',
      earnsAboveMinimum: 'Zarabia powyżej minimum',
      student: 'Student',
      pensionRights: 'Prawa emerytalne',
      rentRights: 'Prawa rentowe',
      voluntarySickness: 'Dobrowolne chorobowe',
      registeredUnemployed: 'Zarejestrowany bezrobotny',
      disabilityCert: 'Orzeczenie o niepełnosprawności',
      taxOffice: 'Urząd skarbowy',
      nfzBranch: 'ZUS / KRUS',
    },
    accepted: 'Zaakceptowano',
    notAccepted: 'Nie zaakceptowano',
    driverAcceptance: 'Akceptacja Kierowcy',
    acceptingDriver: 'Akceptujesz kierowcę',
    company: 'Firma',
    branch: 'Oddział (opcjonalnie)',
    selectCompany: 'Wybierz firmę',
    driverRejection: 'Odrzucenie Kierowcy',
    confirmReject: 'Czy na pewno chcesz odrzucić kierowcę',
    rejectionReasonOptional: 'Powód odrzucenia (opcjonalnie)',
    documentRejection: 'Odrzucenie Dokumentu',
    rejectDocumentLabel: 'Odrzuć dokument',
    rejectionReasonRequired: 'Powód odrzucenia',
    provideRejectionReason: 'Podaj powód odrzucenia',
    rejectDocument: 'Odrzuć Dokument',
    addDocumentTitle: 'Dodaj dokument',
    documentType: 'Typ dokumentu',
    fileLabel: 'Plik (JPG, PNG, PDF, max 25MB)',
    documentNumber: 'Numer dokumentu (opcjonalnie)',
    expiryDate: 'Data ważności (opcjonalnie)',
    upload: 'Prześlij',
    cannotPreview: 'Nie można wyświetlić podglądu tego pliku.',
  },
  driverPage: {
    title: 'Kierowcy',
    driverForm: 'Formularz Kierowcy',
    labels: {
      firstName: 'Imię',
      lastName: 'Nazwisko',
      email: 'Email',
      password: 'Hasło',
      phone: 'Telefon',
      company: 'Firma',
      department: 'Departament',
    },
    searchLabel: 'Szukaj',
  },
  driverDetails: {
    missingRequiredTitle: 'Nie zapisano — brakuje wymaganych pól',
    missingRequiredText: 'Uzupełnij poniższe pola i zapisz ponownie:',
    missingRequiredFallback: 'Sprawdź pola oznaczone na czerwono i zapisz ponownie.',
    tabs: {
      general: 'Ogólne Informacje',
      documents: 'Dokumenty',
      invoices: 'Faktury',
      bonuses: 'Bonusy',
      carRental: 'Wynajem Auta',
      importData: 'Dane z Importu',
      payouts: 'Wypłaty',
      cars: 'Auta',
      bailiffs: 'Komornicy',
      history: 'Historia',
      legalization: 'Legalizacja',
    },
    generalInfo: 'Ogólne Informacje',
    labels: {
      firstName: 'Imię',
      lastName: 'Nazwisko',
      phone: 'Telefon',
      email: 'Email',
      password: 'Hasło',
      passwordHint: 'Zostaw puste, aby nie zmieniać hasła',
      street: 'Ulica',
      homeNumber: 'Numer Domu',
      aptNumber: 'Numer Mieszkania',
      postalCode: 'Kod Pocztowy',
      city: 'Miasto',
      licenseNumber: 'Numer Licencji',
      payoutType: 'Rodzaj Wypłat',
      payoutSchedule: 'Częstotliwość Rozliczeń',
      cooperationType: 'Rodzaj Współpracy',
      zusType: 'Rodzaj ZUS',
      accountNo: 'Numer Konta',
      accountNoHint: '26 cyfr bez spacji lub ze spacjami',
      abroadAccount: 'Konto za granicą?',
      readyForSettlements: 'Gotowy do rozliczeń?',
      missingData: 'Brakujące Dane',
      registerType: 'Sposób Rejestracji',
      department: 'Departament',
    },
    goBack: 'Powrót',
    driverDocuments: 'Dokumenty kierowcy',
    addDocument: 'Dodaj dokument',
    noDocuments: 'Brak dokumentów',
    statusMissing: 'BRAK',
    statusAddedVerified: 'DODANY (zweryfikowany)',
    statusRejected: 'ODRZUCONY',
    statusAddedPending: 'DODANY (oczekuje)',
    addBtn: 'Dodaj',
    reAddBtn: 'Dodaj ponownie',
    previewBtn: 'Podgląd',
    downloadBtn: 'Pobierz',
    acceptBtn: 'Akceptuj',
    rejectBtn: 'Odrzuć',
    deleteBtn: 'Usuń',
    uploadDocTitle: 'Dodaj dokument kierowcy',
    uploadDocType: 'Typ dokumentu',
    uploadDocTypeRequired: 'Wybierz typ dokumentu',
    uploadDocNumber: 'Numer dokumentu (opcjonalnie)',
    uploadExpiryDate: 'Data ważności *',
    uploadExpiryRequired: 'Podaj datę ważności',
    uploadExpiryFuture: 'Data musi być w przyszłości',
    uploadFileLabel: 'Plik (JPG / PNG / WebP / PDF, max 25 MB)',
    uploadFileRequired: 'Wybierz plik',
    docPreviewTitle: 'Podgląd dokumentu',
    invoicesTitle: 'Faktury',
    searchLabel: 'Szukaj',
    bonusFormTitle: 'Formularz Bonusu',
    bonusLabels: {
      file: 'Plik',
      date: 'Data',
      status: 'Status',
      type: 'Typ',
      description: 'Opis',
      amount: 'Kwota',
    },
    bonusesTitle: 'Bonusy',
    downloadFile: 'Pobierz plik',
    carRentalTitle: 'Wynajem Auta',
    importedDataTitle: 'Zaimportowane Dane',
    equationTitle: 'Wzór Obliczeniowy',
    formula: 'Formuła',
    usedVariables: 'Użyte zmienne',
    constant: 'stała',
    calculationSteps: 'Kroki obliczeń',
    calculationResult: 'Wynik obliczeń',
    csvData: 'Dane CSV',
    field: 'Pole',
    value: 'Wartość',
    noDataToDisplay: 'Brak danych do wyświetlenia',
    payoutsTitle: 'Wypłaty',
    settlementSummary: 'Podsumowanie Rozliczenia',
    paid: 'Zapłacony',
    pendingStatus: 'Oczekujący',
    bonusTypePositive: 'Bonus +',
    bonusTypeNegative: 'Kara −',
    bonusTypeRent: 'Najem',
    settlementCalc: 'Kalkulacja rozliczenia',
    calcView: {
      title: 'Kalkulacja „łącznie do rozliczenia"',
      appsEarnings: 'Zarobki z aplikacji (suma „Twój przychód")',
      additionalIncomes: 'Dodatkowe dochody',
      bonusesPositive: 'Bonusy +',
      bonusesNegative: 'Bonusy −',
      rent: 'Najem (z bonusów)',
      cashCollected: 'Gotówka pobrana',
      cashCollectedHint: '(odjęta — kierowca ma ją na rękę)',
      settlementCost: 'Koszt rozliczenia',
      administrationTax: 'Opłata administracyjna',
      dailyAdvances: 'Zaliczki dzienne ({count} ×)',
      dailyAdvancesHint: '(już wypłacone w trakcie tygodnia)',
      dailyPayoutFees: 'Opłaty za szybkie wypłaty',
      dailyPayoutFeesHint: '({count} × 30 PLN)',
      zusContributions: 'Składki ZUS',
      maxCostReimbursement: 'Max zwrot kosztów',
      maxCostReimbursementHint: '(8% × netto z apps)',
      totalLabel: '= ŁĄCZNIE',
    },
    revenues: 'PRZYCHODY',
    fromApps: 'Z aplikacji (BOLT + UBER + FREENOW)',
    additionalIncomes: 'Dochody dodatkowe',
    bonusesPositive: 'Bonusy (+)',
    bonusesNegative: 'Bonusy (-)',
    rentFromBonuses: 'Najem (z bonusów)',
    tipsGross: 'Napiwki brutto',
    tipsVat: 'VAT 23% od napiwków',
    invoiceReturn: 'Zwrot z faktur (max 8% netto = {0})',
    settlementCost: 'Koszt rozliczenia',
    administrationFee: 'Opłata administracyjna',
    cashDeduction: 'Gotówka (potrącenie)',
    dailyAdvancesDeducted: 'Zaliczki dzienne (wypłacone wcześniej)',
    dailyPayoutFees: 'Opłaty za wypłaty dzienne (firma pobrała)',
    maxCostReimbursement: 'Max kwota zwrotu kosztów (8% netto z apps)',
    finalReturnAmount: 'Finalna kwota zwrotu',
    total: '= SUMA',
    zusDeduction: 'POTRĄCENIE ZUS',
    zusCalc: {
      sickness: 'Chorobowe',
      social: 'Społeczne',
      pitAdvance: 'Zaliczka PIT',
      health: 'Zdrowotne',
    },
    afterZus: '= Po odjęciu ZUS',
    transferBreakdown: 'ROZBICIE NA PRZELEWY',
    contractTransfer: 'Zleceniówka',
    contractAlreadyPaid: 'Zleceniówka (już wypłacona w tym mc)',
    remainingAfterContract: 'Pozostałe po zleceniówce',
    costReimbursement: 'Zwrot kosztów',
    rentTransfer: 'Najem',
    transfer: 'PRZELEW',
    invoiceTransfer: 'Przelew z tyt. faktury',
    totalTransfers: 'SUMA PRZELEWÓW (po ZUS)',
    infoNetto8pct: '8% netto z apps',
    infoField: 'pole informacyjne',
    perAppBreakdown: 'Rozliczenie per Aplikacja',
    appHeaders: {
      app: 'Aplikacja',
      brutto: 'Brutto',
      netto: 'Netto',
      onePercentBrutto: '1% z Brutto',
      eightPercentNetto: '8% z Netto',
      calculated: 'Obliczone',
      cash: 'Gotówka',
    },
    totalRow: 'RAZEM',
    zusDeductions: 'Potrącenia ZUS',
    zusHeaders: {
      monthYear: 'Miesiąc/Rok',
      zusType: 'Typ ZUS',
      sickness: 'Chorobowe',
      social: 'Społeczne',
      laborFund: 'Fund. Pracy',
      health: 'Zdrowotne',
      total: 'Suma',
    },
    totalZus: 'RAZEM ZUS',
    quickStats: {
      total: 'Suma',
      zus: 'ZUS',
      contract: 'Zleceniówka',
      costReimbursement: 'Zwrot kosztów',
      maxCost8pct: 'max 8% netto',
      rent: 'Najem',
    },
    appEarnings: 'Przychody z Aplikacji',
    summary: 'Podsumowanie',
    appId: 'ID w aplikacji',
    cooperationType: 'Typ współpracy',
    calculatedAmount: 'Obliczona kwota',
    cashLabel: 'Gotówka',
    csvDataFromFile: 'Dane z CSV',
    invoicesSection: 'Faktury',
    invoiceHeaders: {
      date: 'Data',
      brutto: 'Brutto',
      forDriver: 'Dla Kierowcy',
    },
    bonusesPenalties: 'Bonusy / Kary',
    bonusHeaders: {
      description: 'Opis',
      type: 'Typ',
      amount: 'Kwota',
    },
    incomesSection: 'Przychody',
    incomeHeaders: {
      date: 'Data',
      forDriver: 'Dla Kierowcy',
    },
    noDetailedData: 'Brak szczegółowych danych dla tego rozliczenia.',
    companyCars: 'Auta firmowe (przypisane)',
    noCompanyCars: 'Brak przypisanych aut firmowych do tego kierowcy.',
    mainCar: 'Auto główne',
    additionalCar: 'Auto dodatkowe',
    carLabels: {
      makeModel: 'Marka / Model',
      registration: 'Rejestracja',
      sideNumber: 'Nr boczny',
      color: 'Kolor',
      productionYear: 'Rok produkcji',
      wrapType: 'Oklejenie',
      mileage: 'Przebieg',
      rentPrice: 'Cena najmu',
    },
    licenseExcerpts: 'Wypisy z licencji',
    privateCars: 'Auta dodane przez kierowcę (prywatne)',
    noPrivateCars: 'Brak aut prywatnych',
    bailiffsTitle: 'Komornicy',
    addBailiff: 'Dodaj komornika',
    editBailiff: 'Edytuj komornika',
    noBailiffs: 'Brak komorników',
    bailiffLabels: {
      name: 'Nazwa / Imię i Nazwisko komornika',
      accountNo: 'Numer konta',
      wireTitle: 'Tytuł przelewu',
      address1: 'Adres komornika',
      address2: 'Adres komornika cd.',
      transferTypes: 'Z tytułu których przelewów',
      isActive: 'Aktywny (przelewy idą do tego komornika)',
    },
    historyTitle: 'Historia Kierowcy',
    cooperationTypeHistory: 'Historia Rodzaju Współpracy',
    changes: 'zmian',
    equationLabel: 'Wzór',
    current: 'Aktualny',
    noHistory: 'Brak historii - ustaw rodzaj współpracy aby rozpocząć śledzenie zmian.',
    uploadInvoiceTitle: 'Wgraj fakturę do wypłaty',
    selectInvoiceFile: 'Wybierz plik faktury',
    uploadBtn: 'Wgraj',
    invoicePreviewTitle: 'Podgląd faktury',
    uploaded: 'Wgrana',
    uploadInvoice: 'Wgraj FV',
    docPreview: 'Podgląd dokumentu',
  },
  pendingChanges: {
    title: 'Oczekujące Zmiany Kierowców',
    changesPerPage: 'Zmian na stronę:',
    pageText: '{0}-{1} z {2}',
    loadingText: 'Ładowanie zmian...',
    noDataText: 'Brak zmian do wyświetlenia',
    preview: 'Podgląd',
    approve: 'Zatwierdź',
    reject: 'Odrzuć',
    rejectionReasonOptional: 'Powód odrzucenia (opcjonalnie)',
    changesPreview: 'Podgląd zmian',
    driverLabel: 'Kierowca',
    reportDate: 'Data zgłoszenia',
    currentValues: 'Obecne wartości',
    newValues: 'Nowe wartości',
  },
  archiveDrivers: {
    title: 'Archiwum Kierowców',
    searchLabel: 'Szukaj',
    department: 'Departament',
  },
  bonusPage: {
    title: 'Bonusy',
    searchLabel: 'Szukaj',
    dateFrom: 'Data Od',
    dateTo: 'Data Do',
    driverLabel: 'Kierowca',
    downloadFile: 'Pobierz plik',
    bonusForm: 'Formularz Bonusu',
    labels: {
      file: 'Plik',
      date: 'Data',
      driver: 'Kierowca',
      status: 'Status',
      type: 'Typ',
      description: 'Opis',
      amount: 'Kwota',
    },
  },
  company: {
    title: 'Firma',
    addCompany: 'Dodaj firmę',
    editCompany: 'Edytuj firmę',
    newCompany: 'Nowa firma',
    address: 'Adres',
    addressCont: 'Adres cd.',
    zipCode: 'Kod Pocztowy',
    city: 'Miasto',
    country: 'Kraj',
    taxCode: 'NIP',
    automaticPayouts: 'Automatyczne wypłaty',
  },
  subCompany: {
    title: 'Oddziały',
    addTitle: 'Dodawanie',
    assignToAll: 'Przypisz oddział do wszystkich administratorów',
    assignToAllHint: 'Nowy oddział będzie widoczny dla każdego admina w firmie',
  },
  admins: {
    title: 'Administratorzy',
    formTitle: 'Formularz',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    password: 'Hasło',
    phone: 'Telefon',
    mainCompany: 'Firma główna',
    mainCompanyHint: 'Domyślna firma po zalogowaniu',
    accessAllCompanies: 'Dostęp do wszystkich firm',
    accessAllCompaniesHint: 'Administrator może przełączać się między wszystkimi firmami w systemie',
    additionalCompanies: 'Dodatkowe firmy z dostępem',
    additionalCompaniesHint: 'Firmy, na które administrator może się przełączać (oprócz firmy głównej)',
    branch: 'Oddział',
    role: 'Rola',
    pagePermissions: 'Uprawnienia do stron',
    previewAll: 'Podgląd wszystkich',
    clear: 'Wyczyść',
    page: 'Strona',
    preview: 'Podgląd',
    editPerm: 'Edycja',
    superadminHint: 'Superadministrator ma pełny dostęp niezależnie od zaznaczeń.',
  },
  bankAccounts: {
    title: 'Konta Bankowe',
    addAccountTitle: 'Dodawanie Konta',
    accountNumber: 'Numer',
    bankName: 'Nazwa Banku',
    bankNameHint: 'Wybierz z listy lub wpisz własną nazwę',
    bankAccountNumberRule: 'Podaj 26 cyfr (PL) lub IBAN (np. DE89370400440532013000)',
  },
  login: {
    password: 'Hasło',
    loginButton: 'Zaloguj',
    enterEmail: 'Podaj adres e-mail',
    enterPassword: 'Podaj hasło',
    failedTitle: 'Nie udało się zalogować',
    invalidCredentials: 'Nieprawidłowy e-mail lub hasło. Sprawdź dane i spróbuj ponownie.',
    genericError: 'Coś poszło nie tak. Spróbuj ponownie za chwilę.',
    ok: 'Spróbuj ponownie',
  },
  dashboard: {
    filters: 'Filtry',
    branch: 'Oddział',
    weekFrom: 'Od tygodnia',
    weekTo: 'Do tygodnia',
    settlementType: 'Rodzaj Rozliczenia',
    drivers: 'Kierowcy',
    payoutsPeriod: 'Wypłaty (okres)',
    pendingInvoices: 'Oczekujące FV',
    zusAmountPeriod: 'Kwota ZUS (okres)',
    rentalIncome: 'Przychód z Najmu',
    vat8Net: '8% od zarobków kierowców',
    onePercentGross: '1% od Brutto',
    totalIncomes: 'Suma Przychodów',
    paid: 'Wypłacone',
    toPay: 'Do Wypłaty',
    totalToPay: 'Łącznie do Wypłaty',
    published: 'Opublikowane',
    payoutsBySchedule: 'Wypłaty wg Harmonogramu',
    pending: 'W toku (brutto)',
    pendingHint: 'Brutto szacunkowe — zarobki kierowców z PENDING bonusami/importami w zakresie. Wartość PRZED odjęciem ZUS (typowo 50–500 zł na kierowcę), więc finalna wypłata będzie nieco niższa. Koszt rozliczenia + opłata admin (30 zł) JUŻ odjęte. Po kliknięciu "Rozlicz" w PayoutsPage liczba przejdzie z "W toku" do "Razem".',
    monthlyPending: 'Miesięczni — w toku',
    monthlyPendingHint: 'Sumaryczne brutto szacunkowe wypłaty kierowców MIESIĘCZNYCH za bieżący zakres dat. Pomocne do planowania cashflow przed Rozlicz na koniec miesiąca.',
    schedule: 'Harmonogram',
    count: 'Liczba',
    total: 'Razem',
    statusPaid: 'Wypłacono',
    statusPartial: 'Częściowo',
    statusPending: 'Oczekuje',
    invoicesByVat: 'Faktury wg Stawki VAT',
    vatRate: 'Stawka VAT',
    gross: 'Brutto',
    net: 'Netto',
    driverReturn: 'Zwrot dla kierowcy',
    incomeSummary: 'Podsumowanie Przychodów',
    rentalIncomeTotal: 'Przychód z Najmu (łącznie)',
    fromImports: '- z importów (CSV)',
    fromBonuses: '- z bonusów najmu',
    fromSettlements: '- z rozliczeń',
    vat8Income: 'Przychód z 8% VAT',
    onePercentGrossCsv: '1% od Brutto (CSV)',
    totalGrossImport: 'Suma Brutto z importu',
    totalIncomesModel: 'Suma Przychodów (model)',
    paidIncomes: 'Wypłacone przychody',
    unpaidIncomes: 'Niewypłacone przychody',
    driversByCoopType: 'Kierowcy wg Typu Współpracy',
    type: 'Typ',
    driversByZusType: 'Kierowcy wg Typu ZUS',
    zusType: 'Typ ZUS',
    payoutsByCoopType: 'Wypłaty wg Typu Współpracy (okres)',
    amount: 'Kwota',
    driversByPayoutSchedule: 'Kierowcy wg Harmonogramu Wypłat',
    recentPayouts: 'Ostatnie Wypłaty (okres)',
    recentInvoices: 'Ostatnie FV do Akceptacji',
    integrationsBlikTitle: 'Integracje API + Wypłaty BLIK',
    todayBlikRequests: 'Dzisiejsze żądania BLIK',
    pendingApproval: 'Oczekują akceptacji',
    reviewQueue: 'Zobacz kolejkę',
    weekSelfService: 'BLIK (tydzień)',
    weekBoltDaily: 'Wypłaty dzienne Bolt (tydzień)',
    payoutsUnit: 'wypłat',
    integrationsStatus: 'Status integracji',
    intOk: 'OK',
    intError: 'błąd',
    intNotConfigured: 'nieskonfigurowane',
    enabled: 'włączone',
    disabled: 'wyłączone',
    feesTodayCompany: 'Opłaty dzisiaj (firma)',
    feesWeekCompany: 'Opłaty tydzień (firma)',
    fromDailyFees: 'z opłat 30 zł',
    avgBlikAmount: 'Średnia wypłata BLIK',
    perRequest: 'per żądanie',
    successRate: 'Skuteczność',
    requestsUnit: 'żądań',
    monthSummary: 'Podsumowanie miesiąca',
    totalPaid: 'wypłacone',
    feesToCompany: 'przychód firmy',
    driversEarningsToday: 'Zarobki kierowców (obecny okres)',
    driversCashToday: 'Gotówka w kieszeniach kierowców',
    driversWithEarnings: 'kierowców z zarobkami',
    inDriverPockets: 'już wzięte przez kierowców',
    companyRevenueToday: 'Przychód firmy dziś',
    earningsBySubCompanyToday: 'Zarobki per oddział (obecny okres)',
    earningsTotal: 'Zarobki',
    cashCollectedTotal: 'Pobrana gotówka',
    totalLabel: 'ŁĄCZNIE',
    edit: 'Edytuj dashboard',
    editDone: 'Zapisz układ',
    editReset: 'Resetuj',
    editHint: 'Przeciągnij widgety na dashboard. Na karcie zmień rozmiar lub ukryj.',
    noHiddenWidgets: 'Wszystkie widgety są już na dashboardzie',
    layoutSaved: 'Układ zapisany',
    layoutReset: 'Układ zresetowany do domyślnego',
    confirmReset: 'Zresetować układ do domyślnego?',
    apiLiveTitle: 'Live z API (Bolt + Uber)',
    apiLiveHint: 'Pobiera aktualne zarobki z API za wybrany zakres dat',
    apiLiveClickFetch: 'Kliknij „Pobierz" żeby zaciągnąć dane z API',
    apiLiveLoading: 'Pobieram z Bolt/Uber API...',
    fetch: 'Pobierz',
    apiGross: 'Brutto',
    apiNet: 'Netto',
    apiCash: 'Gotówka',
    apiDrivers: 'kierowców',
    apiOrders: 'kursów',
    perSource: 'Per aplikacja',
    perBranch: 'Per oddział',
    apiUnmatched: '{n} kierowców w API nie ma odpowiednika u nas.',
    syncDrivers: 'Synchronizuj kierowców',
    legacyTitle: 'Pełny dashboard (klasyczny)',
    hideWidget: 'Ukryj widget',
    revenueChartTitle: 'Przychody (wykres)',
    earningsByPlatformPie: 'Zarobki per aplikacja (wykres kołowy)',
    platformCommissions: 'Prowizje aplikacji',
    appEarningsSummary: 'Zarobki z aplikacji',
    financeBreakdown: 'Finanse firmy — rozbicie',
    revenueBreakdown: 'Przychód firmy — składniki',
    costBreakdown: 'Koszty stałe',
    chartSourceDb: 'z bazy',
    chartSourceApi: 'z API (live)',
    fetchFromApi: 'Pobierz z API',
    switchToDb: 'Wróć do bazy',
    chartApiTimedOut: 'Pobieranie z API trwało za długo (>45s) — pokazuję częściowe wyniki. Spróbuj krótszego zakresu.',
    chartFetchTime: 'Czas pobierania',
  },
  generationReport: {
    title: 'Raport generowania rozliczeń',
    feesTitle: 'Opłaty doliczone do długu: {count}',
    feesBoundary: 'Osobny etap naliczania opłat. Nie są to utworzone wypłaty; lista może zawierać osoby spoza powyższej puli kandydatów.',
    feesIncomplete: 'Etap opłat nie został ukończony lub nie został rozpoczęty. Lista może być częściowa.',
    noFees: 'Brak zarejestrowanych naliczeń w tym raporcie.',
    lastReport: 'Ostatni raport',
    openReport: 'Otwórz raport',
    history: 'Historia w Logach zdarzeń',
    historyAccess: 'Zapisane raporty są dostępne w Logach zdarzeń dla osób z uprawnieniem do tej sekcji.',
    summary: 'Utworzono: {created} · pominięto: {skipped} · błędy: {failed} · nieprzetworzone: {notProcessed}',
    partialFailure: 'Generowanie przerwano. Część rozliczeń mogła już powstać. Przed ponowieniem sprawdź wyniki poszczególnych osób; raport nie oznacza cofnięcia operacji.',
    notSaved: 'Nie zapisano raportu w historii. Wynik jest dostępny tylko w tym widoku do czasu jego opuszczenia. Nie ponawiaj generowania wyłącznie w celu zapisania raportu.',
    scopeTitle: 'Zakres tej operacji', period: 'Okres', search: 'Wyszukiwanie przy generowaniu', noSearch: 'Bez wyszukiwania',
    departments: 'Oddziały (identyfikatory filtra)', allDepartments: 'Wszystkie dostępne w zakresie firmy',
    schedule: 'Harmonogram', allSchedules: 'Wszystkie', threshold: 'Próg wypłaty',
    unknownThreshold: 'Nie ustalono przed przerwaniem operacji', greaterThan: 'Ściśle powyżej {amount}',
    candidates: 'Rozpatrywani kandydaci', unknownCandidates: 'Nie ustalono listy', onlyDriver: 'Tylko kierowca (ID)', mode: 'Tryb', onDemand: 'Na żądanie',
    scopeBoundary: 'Raport dotyczy wyłącznie rozpatrywanych kandydatów z dodatniej puli po zastosowaniu filtrów i limitu pobierania. Nie obejmuje całej kartoteki ani osób poza tą pulą — nie wyjaśnia ich nieobecności.',
    findDriver: 'Szukaj kierowcy, ID lub przyczyny w raporcie', result: 'Wynik', allResults: 'Wszystkie wyniki',
    driver: 'Kierowca', reason: 'Powód / szczegóły', candidateAmount: 'Kwota przed generowaniem', payout: 'Utworzona wypłata',
    comparison: 'Wartość: {actual} · wymagane minimum: {required}', settlementId: 'ID rozliczenia',
    noMatches: 'Brak wyników dla wybranych filtrów raportu.', noCandidates: 'Raport nie zawiera rozpatrywanych kandydatów. Sprawdź zakres i ewentualny błąd powyżej.',
    rows: 'Wiersze {from}–{to} z {total}', runId: 'ID operacji',
    savedHint: 'Raport zapisany w Logach zdarzeń (dostęp zgodny z uprawnieniami).', memoryHint: 'Raport nie jest zapisany w historii.',
    counts: { created: 'Utworzone', skipped: 'Pominięte', failed: 'Błędy', notProcessed: 'Nieprzetworzone' },
    outcomes: { CREATED: 'Utworzono', SKIPPED: 'Pominięto', FAILED: 'Błąd', NOT_PROCESSED: 'Nieprzetworzony' },
    schedules: { DAILY: 'Dziennie', WEEKLY: 'Tygodniowo', EVERY_2_WEEKS: 'Co 2 tygodnie', MONTH: 'Miesięcznie', MONTHLY: 'Miesięcznie' },
    legacyTitle: 'Zakończono — starsza wersja odpowiedzi',
    legacyHint: 'Backend nie zwrócił szczegółowego raportu. Ta odpowiedź nie potwierdza utworzenia rozliczenia dla każdej osoby.',
    legacyOdometer: 'Pominięci — brak przebiegu:', legacyInspection: 'Pominięci — wezwanie na inspekcję:', legacyFees: 'Opłata doliczona do długu:',
    requestFailed: 'Nie udało się potwierdzić pełnego wyniku generowania. Sprawdź rozliczenia i Logi zdarzeń przed ponowieniem.',
    errorTitle: 'Nie potwierdzono zakończenia',
    refreshFailed: 'Nie odświeżono listy rozliczeń. Otrzymany raport pozostaje dostępny; przed kolejną operacją sprawdź aktualność listy.',
  },
  settlements: {
    title: 'Rozliczenia',
    filters: 'Filtry',
    department: 'Departament',
    week: 'Tydzień',
    settlementType: 'Rodzaj Rozliczenia',
    tableVisibility: 'Widoczność Tabel',
    negative: 'Na minusie',
    deletedDrivers: 'Usunięci kierowcy',
    settle: 'Rozlicz!',
  },
  debtors: {
    title: 'Lista dłużników',
    subtitle: 'Kierowcy z ujemnym saldem narastająco (suma wszystkich rozliczeń). Aktualizuje się z każdym nowym rozliczeniem.',
    totalDebt: 'Łączny dług',
    debtorsCount: 'dłużników',
    search: 'Szukaj (imię, nazwisko, telefon)',
    refresh: 'Odśwież',
    empty: 'Brak dłużników — wszyscy na plusie lub 0.',
    driver: 'Kierowca',
    type: 'Typ',
    balance: 'Saldo (dług)',
    earnings: 'Zarobki',
    rent: 'Najem',
    weeksTitle: 'Rozliczenia tygodniowe',
    week: 'Tydzień',
    weekBalance: 'Saldo tygodnia',
  },
  payouts: {
    title: 'Wypłaty',
    filters: 'Filtry',
    branch: 'Oddział',
    week: 'Tydzień',
    settlementType: 'Rodzaj Rozliczenia',
    receiptsTab: 'Pokwitowania',
    costInvoicePool: 'Pula Faktur Kosztowych',
    collapse: 'Zwiń',
    expand: 'Rozwiń',
    pool: 'Pula',
    allocated: 'Przydzielono',
    remaining: 'Pozostało',
    invoiceCount: 'Liczba FV',
    activeAllocations: 'Aktywne alokacje',
    amount: 'Kwota',
    admin: 'Admin',
    action: 'Akcja',
    revert: 'Cofnij',
    publishAll: 'Opublikuj Wszystkie',
    unpublishAll: 'Ukryj Wszystkie',
    revertAll: 'Cofnij Wszystkie',
    wiresPaid: 'Przelewy Wypłacone',
    allPaid: 'Wszystkie Wypłacone',
    generateBaskets: 'Generuj koszyki',
    invoiceBased: 'z tyt. faktury',
    uploaded: 'Wgrana',
    invoicePendingReview: 'Do akceptacji',
    invoiceAccepted: 'Zaakceptowana',
    invoiceRejected: 'Odrzucona',
    acceptInvoice: 'Akceptuj fakturę',
    rejectInvoice: 'Odrzuć fakturę',
    rejectReasonTitle: 'Powód odrzucenia faktury',
    rejectReasonHint: 'Np. błędna kwota, brak adnotacji o gotówce…',
    acceptInvoiceConfirm: 'Zaakceptować fakturę? Odblokuje to wypłatę.',
    markInvoice: 'Oznacz FV',
    uploadInvoice: 'Wgraj FV',
    paidWire: 'Wypłacono (przelew)',
    paidCash: 'Wypłacono (gotówka)',
    publish: 'Opublikuj',
    unpublish: 'Ukryj',
    allocateFromPool: 'Przydziel z puli kosztowej',
    remainingInPool: 'Pozostało w puli',
    currentCostReimbursement: 'Aktualny zwrot kosztów',
    currentRent: 'Aktualny najem',
    amountPLN: 'Kwota (PLN)',
    allocate: 'Przydziel',
    uploadInvoiceTitle: 'Wgraj fakturę',
    selectInvoiceFile: 'Wybierz plik faktury',
    upload: 'Wgraj',
    invoicePreview: 'Podgląd faktury',
    generateTransfersTitle: 'Generuj koszyki przelewów',
    bankFormat: 'Format banku',
    senderAccount: 'Rachunek nadawcy',
    senderName: 'Nazwa nadawcy (z firmy)',
    transferDescription: 'Zostaną wygenerowane osobne pliki dla każdego typu przelewu: zleceniówka, zwrot kosztów, najem, komornik. Format: ELIXIR-O (CSV).',
    generate: 'Generuj',
    cashReceiptTitle: 'Pokwitowanie wypłaty gotówkowej',
    driverSignature: 'Podpis kierowcy (odbiorcy)',
    workerSignature: 'Podpis pracownika (wypłacającego)',
    saveWithoutSignature: 'Zapisz bez podpisu',
    saveAndPrint: 'Zapisz i drukuj',
    receiptFilters: 'Filtry pokwitowań',
    searchDriver: 'Szukaj kierowcy',
    cashReceipts: 'Pokwitowania wypłat gotówkowych',
    driverSigned: 'Podpis kierowcy',
    noDriverSignature: 'Brak podpisu kierowcy',
    workerSigned: 'Podpis pracownika',
    noWorkerSignature: 'Brak podpisu pracownika',
    printReceipt: 'Drukuj pokwitowanie',
  },
  contracts: {
    title: 'Zleceniówka',
    filters: 'Filtry',
    branch: 'Oddział',
    week: 'Tydzień',
    settlementType: 'Rodzaj Rozliczenia',
  },
  receipts: {
    title: 'Rachunki',
    month: 'Miesiąc',
    searchDriver: 'Szukaj kierowcy',
    downloadZip: 'Pobierz ZIP',
    downloadPdf: 'Pobierz PDF',
  },
  costInvoices: {
    title: 'Faktury Kosztowe',
    uploadTitle: 'Wgrywanie Faktury',
    file: 'Plik',
    brutto23: 'Kwota (Brutto 23%)',
    netto23: 'Kwota (Netto 23%)',
    brutto8: 'Kwota (Brutto 8%)',
    netto8: 'Kwota (Netto 8%)',
    brutto5: 'Kwota (Brutto 5%)',
    netto5: 'Kwota (Netto 5%)',
    brutto0: 'Kwota (Brutto 0%)',
    netto0: 'Kwota (Netto 0%)',
  },
  incomes: {
    title: 'Przychody',
    formTitle: 'Formularz Przychodu',
    file: 'Plik',
    brutto: 'Kwota (Brutto)',
    netto: 'Kwota (Netto)',
    taxPercent: 'Podatek (%)',
  },
  tasks: {
    myTasks: 'Moje',
    myTasksTitle: 'Moje zadania',
    popup: {
      title: 'Nowe zadanie',
      dueTitle: 'Zbliża się termin zadania',
      newLabel: 'Wymaga rozpoczęcia',
      dueLabel: 'Termin w ciągu 24 godzin',
      counter: 'Zadanie {current} z {total}',
      start: 'Rozpocznij zadanie',
      ack: 'Potwierdzam, widzę',
      snooze: 'Przypomnij za 1 godzinę',
      postpone: 'Odrocz 1 dzień',
      deadline: 'Termin wykonania',
    },
    title: 'Zadania',
    active: 'Aktywne',
    archive: 'Archiwum',
    archiveTitle: 'Archiwum zadań',
    statistics: 'Statystyki',
    addTask: 'Dodaj zadanie',
    editTask: 'Edytuj zadanie',
    deleteTask: 'Usuń zadanie',
    newTask: 'Nowe zadanie',
    create: 'Utwórz',
    taskTitle: 'Tytuł zadania',
    taskDescription: 'Opis zadania',
    taskType: 'Typ zadania',
    priority: 'Priorytet',
    recordType: 'Typ rekordu',
    linkedRecord: 'Powiązany rekord',
    assignTo: 'Przypisz do',
    dueDate: 'Termin wykonania',
    notes: 'Notatki',
    addNote: 'Dodaj notatkę',
    noMessages: 'Brak wiadomości',
    unassigned: 'Nieprzypisane',
    typeInternal: 'Wewnętrzne',
    typeLinked: 'Powiązane',
    clickToChangeStatus: 'Kliknij aby zmienić status',
    statisticsTitle: 'Statystyki zadań',
    tasksByUsers: 'Zadania według użytkowników',
  },
  notifications: {
    read: 'Przeczytane',
    unread: 'Nieprzeczytane',
    detailsTitle: 'Szczegóły powiadomienia',
    text: 'Tekst',
    createdAt: 'Stworzono o',
    details: 'Szczegóły',
    type: 'Typ',
    reason: 'Powód',
    approvedById: 'Zatwierdzony przez ID',
    approvedAt: 'Zatwierdzony o',
    rejectedById: 'Odrzucony przez ID',
    rejectedAt: 'Odrzucony o',
  },
  notificationLogs: {
    title: 'Historia wysyłki powiadomień',
    entries: 'wpisów',
    searchPlaceholder: 'Szukaj (typ, email, telefon, treść)',
    channel: 'Kanał',
    refresh: 'Odśwież',
    detailTitle: 'Szczegóły powiadomienia',
    type: 'Typ',
    priorityLabel: 'Priorytet',
    recipientId: 'Odbiorca ID',
    phone: 'Telefon',
    email: 'Email',
    messageTitle: 'Tytuł',
    content: 'Treść',
    errorLabel: 'Błąd',
  },
  chat: {
    companyChat: 'Komunikacja firmowa',
    channels: 'Kanały',
    online: 'online',
    selectChannel: 'Wybierz kanał',
    emptyChannel: 'Kanał jest pusty. Napisz pierwszą wiadomość!',
    file: 'Plik',
    photo: 'Zdjęcie',
    template: 'Szablon',
    messageTo: 'Wiadomość do',
    editChannel: 'Edytuj kanał',
    newChannel: 'Nowy kanał',
    createChannel: 'Utwórz',
    channelName: 'Nazwa kanału',
    channelNameHint: 'Np. Ważne info, Grafik, Rozliczenia',
    channelType: 'Typ kanału',
    channelColor: 'Kolor kanału',
    channelIcon: 'Ikona kanału',
    channelIconHint: 'Wybierz z palety lub wpisz własny emoji',
    confirmation: 'Potwierdzenie',
    deleteChannelConfirm: 'Usunąć kanał #{name}? Wszystkie wiadomości zostaną utracone.',
  },
  sms: {
    sendSms: 'Wyślij SMS',
    sendHistory: 'Historia wysyłek',
    replies: 'Odpowiedzi',
    composerEyebrow: 'Centrum wiadomości',
    composerTitle: 'Napisz czytelny SMS',
    composerSubtitle: 'Twórz wiadomości z akapitami i od razu sprawdzaj, jak zobaczy je odbiorca.',
    livePreview: 'Podgląd na żywo',
    chooseRecipients: 'Wybierz odbiorców',
    chooseRecipientsHint: 'Wyślij wiadomość do jednej osoby albo całej grupy.',
    readyRecipients: 'Gotowych odbiorców',
    writeMessage: 'Napisz wiadomość',
    writeMessageHint: 'Entery, odstępy i akapity zostaną zachowane w wysłanym SMS-ie.',
    quickInsert: 'Szybkie wstawianie',
    greeting: 'Powitanie',
    newParagraph: 'Nowy akapit',
    btpSignature: 'Podpis BTP',
    messagePlaceholder: 'Dzień dobry,\n\nwpisz tutaj treść wiadomości...\n\nPozdrawiamy,\nZespół BTP',
    characters: 'Znaki',
    smsParts: 'Części SMS',
    encoding: 'Kodowanie',
    currentPart: 'Bieżąca część',
    remainingInPart: 'Pozostało w tej części: {count}',
    unicodeHint: 'Polskie znaki i emoji włączają Unicode: 70 znaków w pierwszym SMS-ie, 67 w kolejnych.',
    stripPolish: 'Usuń polskie znaki (tańsze SMS-y — 160 znaków na część zamiast 70)',
    previewLabel: 'podgląd wiadomości',
    emptyPreview: 'Tutaj zobaczysz wiadomość dokładnie z zachowaniem akapitów.',
    justNow: 'teraz',
    totalEstimate: 'Szacunkowo: {recipients} odbiorców × {parts} części = {total} SMS',
    formattingPreserved: 'Akapity i odstępy widoczne w podglądzie zostaną zachowane.',
    templates: 'Szablony',
    schedule: 'Zaplanuj',
    limitReached: 'Osiągnięto limit wiadomości',
    clearDraftTitle: 'Wyczyścić szkic?',
    clearDraftText: 'Treść wiadomości i wybrani odbiorcy zostaną usunięci.',
    singlePerson: 'Pojedyncza osoba',
    bulkSend: 'Wysyłka masowa',
    recipient: 'Odbiorca',
    searchByNameOrPhone: 'Wyszukaj po imieniu, nazwisku lub nr telefonu...',
    noResults: 'Brak wyników',
    phoneNumber: 'Nr telefonu',
    phoneRequired: 'Nr telefonu jest wymagany',
    targetGroup: 'Grupa docelowa',
    department: 'Oddział',
    selectPeople: 'Wybierz osoby',
    typeToSearch: 'Wpisz aby wyszukać...',
    recipientsCount: 'Odbiorcy',
    people: 'osób',
    message: 'Wiadomość',
    total: 'Łącznie',
    smsMessage: 'Wiadomość SMS',
    contentRequired: 'Treść jest wymagana',
    maxChars: 'Max 320 znaków',
    chars: 'znaków',
    allowReply: 'Możliwość odpowiedzi',
    send: 'Wyślij',
    sendTo: 'Wyślij do',
    clear: 'Wyczyść',
    smsHistory: 'Historia wysyłek SMS',
    single: 'Pojedyncza',
    bulk: 'Masowa',
    messageDetails: 'Szczegóły wiadomości',
    sender: 'Nadawca',
    content: 'Treść',
    person: 'Osoba',
    smsReplies: 'Odpowiedzi SMS',
    reply: 'Odpowiedz',
    markRead: 'Przeczytane',
    bulkConfirmTitle: 'Potwierdzenie wysyłki masowej',
    bulkConfirmText: 'Czy na pewno chcesz wysłać SMS do {count} osób? Tej operacji nie można cofnąć.',
    totalSmsCount: 'Łączna ilość SMS-ów',
    confirmAndSend: 'Potwierdź i wyślij',
  },
  email: {
    title: 'E-mail',
    sendEmail: 'Wyślij e-mail',
    sendHistory: 'Historia wysyłki',
    singlePerson: 'Pojedyncza osoba',
    bulkSend: 'Wysyłka masowa',
    recipient: 'Odbiorca',
    searchByNameOrEmail: 'Szukaj po nazwisku lub e-mailu',
    noResults: 'Brak wyników',
    email: 'Adres e-mail',
    emailRequired: 'Adres e-mail jest wymagany',
    targetGroup: 'Grupa docelowa',
    department: 'Oddział',
    selectPeople: 'Wybierz osoby',
    typeToSearch: 'Zacznij pisać, aby wyszukać',
    recipientsCount: 'Liczba odbiorców',
    people: 'osób',
    subject: 'Temat',
    subjectRequired: 'Temat jest wymagany',
    maxChars: 'Przekroczono limit znaków',
    message: 'Treść',
    emailMessage: 'Treść wiadomości',
    contentRequired: 'Treść jest wymagana',
    send: 'Wyślij',
    sendTo: 'Wyślij do',
    clear: 'Wyczyść',
    emailHistory: 'Historia e-maili',
    all: 'Wszystkie',
    single: 'Pojedyncza',
    bulk: 'Masowa',
    messageDetails: 'Szczegóły wiadomości',
    sender: 'Nadawca',
    content: 'Treść',
    person: 'Osoba',
    recipientColumn: 'Odbiorca(y)',
    actions: 'Akcje',
    sentTitle: 'E-mail wysłany!',
    sendFailed: 'Nie udało się wysłać e-maila',
    bulkDoneTitle: 'Wysyłka zakończona!',
    bulkQueuedTitle: 'Wysyłka rozpoczęta',
    bulkQueuedText: 'Wiadomości wychodzą w tle, w odstępach chroniących skrzynkę przed blokadą. Postęp zobaczysz w historii wysyłek.',
    sent: 'Wysłano',
    errors: 'Błędy',
    detailFailed: 'Nie udało się pobrać szczegółów',
    resentTitle: 'Ponowiono!',
    bulkConfirmTitle: 'Potwierdź wysyłkę masową',
    bulkConfirmText: 'Czy na pewno chcesz wysłać e-mail do {count} osób? Tej operacji nie można cofnąć.',
    confirmAndSend: 'Potwierdź i wyślij',
    status: {
      SENT: 'Wysłano',
      FAILED: 'Błąd',
      PARTIAL: 'Częściowo',
      PENDING: 'Oczekujący',
    },
  },
  policySales: {
    title: 'Sprzedaż polis',
    summaryTotal: 'Suma wszystkich polis',
    summaryPaid: 'Opłacone',
    summaryUnpaid: 'Nieopłacone',
    policiesCount: 'Liczba polis',
    addButton: 'Dodaj polisę',
    addPolicy: 'Dodaj polisę',
    editPolicy: 'Edytuj polisę',
    buyerName: 'Kto zakupił',
    policyNumber: 'Nr polisy',
    subject: 'Na co polisa',
    amount: 'Kwota',
    paid: 'Opłacona',
    unpaid: 'Nieopłacona',
    paidCheckbox: 'Polisa opłacona',
    paidAt: 'Data opłacenia',
    file: 'Plik',
    attachment: 'Załącznik (skan polisy)',
    currentFile: 'Obecny plik',
    replaceFileHint: 'wybierz nowy, aby zastąpić',
    filterAll: 'Wszystkie',
    monthFilter: 'Miesiąc',
    fieldRequired: 'Pole wymagane',
    invalidAmount: 'Nieprawidłowa kwota, np. 1234,56',
    loadFailed: 'Nie udało się pobrać listy polis',
    saveFailed: 'Nie udało się zapisać polisy',
    added: 'Polisa dodana',
    updated: 'Polisa zaktualizowana',
    deleted: 'Polisa usunięta',
    deleteFailed: 'Nie udało się usunąć polisy',
    downloadFailed: 'Nie udało się pobrać pliku',
    markPaidTitle: 'Oznaczyć polisę jako opłaconą?',
    markUnpaidTitle: 'Oznaczyć polisę jako nieopłaconą?',
    deleteTitle: 'Usunąć polisę?',
  },
  serviceApprovals: {
    title: 'Akceptacja serwisów',
    pendingInfo: 'Serwisy oczekujące na akceptację',
    car: 'Pojazd',
    driver: 'Kierowca',
    serviceType: 'Typ serwisu',
    workshop: 'Warsztat',
    cost: 'Koszt',
    description: 'Opis',
    attachments: 'Faktury / załączniki',
    attachment: 'Załącznik',
    approve: 'Zatwierdź',
    reject: 'Odrzuć',
    approved: 'Zaakceptowany',
    rejected: 'Odrzucony',
    approveTitle: 'Zatwierdzić serwis?',
    rejectTitle: 'Odrzucić serwis?',
    rejectReasonPlaceholder: 'Powód odrzucenia (opcjonalnie)',
    statusPending: 'Oczekujące',
    statusApproved: 'Zaakceptowane',
    statusRejected: 'Odrzucone',
    loadFailed: 'Nie udało się pobrać listy serwisów',
    actionFailed: 'Nie udało się zapisać decyzji',
    fileError: 'Nie udało się otworzyć załącznika',
  },
  documentTemplates: {
    title: 'Szablony Dokumentów',
    uploadTemplate: 'Wgraj szablon',
    templateName: 'Nazwa szablonu',
    uploadDocx: 'Wgraj plik .docx',
    extractedVariables: 'Wyodrębnione zmienne',
    requiredForDriver: 'Wymagane dla kierowcy',
    upload: 'Wgraj',
  },
  pendingDocuments: {
    title: 'Oczekujące Dokumenty',
    docsPerPage: 'Dokumentów na stronę:',
    of: 'z',
    loadingDocs: 'Ładowanie dokumentów...',
    noDocsToShow: 'Brak dokumentów do wyświetlenia',
    signed: 'Podpisany',
    requiredBadge: 'WYMAGANY',
    optional: 'Opcjonalny',
    signature: 'Podpis',
    documentSignature: 'Podpis dokumentu',
    document: 'Dokument',
    signatureDate: 'Data podpisu',
    driverSignature: 'Podpis kierowcy',
    documentPreview: 'Podgląd dokumentu',
  },
  documentsRepository: {
    title: 'Repozytorium Dokumentów',
    addDocument: 'Dodaj dokument',
    company: 'Firmowe',
    signedByDrivers: 'Podpisane przez kierowców',
    searchDocuments: 'Szukaj dokumenty...',
    contracts: 'Umowy',
    protocols: 'Protokoły',
    declarations: 'Oświadczenia',
    regulations: 'Regulaminy',
    other: 'Inne',
    noDocuments: 'Brak dokumentów',
    searchDriver: 'Szukaj kierowcy...',
    noSignedDocuments: 'Brak podpisanych dokumentów',
    kind: 'Rodzaj',
    titleDescription: 'Tytuł / Opis',
    additional: 'Dodatkowe',
    files: 'Pliki',
    documentLabel: 'Dokument',
    protocolLabel: 'Protokół',
    accepted: 'Zaakceptowane',
    documentName: 'Nazwa dokumentu',
    nameRequired: 'Nazwa jest wymagana',
    category: 'Kategoria',
    categoryRequired: 'Kategoria jest wymagana',
    file: 'Plik',
    fileRequired: 'Plik jest wymagany',
  },
  fleet: {
    title: 'Flota',
    cars: 'Auta',
    subFleets: 'Podfloty',
    endingRent: 'Kończenie najmu',
    endDate: 'Data zakończenia',
    carPhotos: 'Zdjęcia Auta',
    notes: 'Uwagi',
    dieselLevel: 'Poziom diesla',
    petrolLevel: 'Poziom benzyny',
    lpgLevel: 'Poziom LPG',
    protocolComparison: 'Porównanie Protokołów',
    subFleet: 'Podflota',
    new: 'Nowa',
    subFleetName: 'Nazwa podfloty',
    parentSubFleet: 'Nadrzędna podflota (opcjonalnie)',
    assignCarToSubFleet: 'Przypisz auto do podfloty',
    assignToMainFleet: 'Przypisz do floty głównej',
    newSubFleet: 'Nowa podflota',
    ownerData: 'Dane Właściciela',
    fees: 'Opłaty',
    settlement: 'Rozliczenie',
    carsAndDrivers: 'Auta i Kierowcy',
    ownerFullName: 'Imię i nazwisko właściciela',
    companyName: 'Nazwa firmy',
    address: 'Adres',
    phone: 'Telefon',
    bankAccountNo: 'Nr konta bankowego',
    saveOwnerData: 'Zapisz dane właściciela',
    feeType: 'Typ opłaty',
    fixedBaseAmount: 'Stała kwota bazowa (PLN)',
    billingPeriod: 'Okres rozliczeniowy',
    dayOfMonth: 'Dzień miesiąca (rozliczenie)',
    saveFeeConfig: 'Zapisz konfigurację opłat',
    month: 'Miesiąc',
    year: 'Rok',
    calculateSettlement: 'Oblicz rozliczenie',
    totalRent: 'Całkowity najem',
    btpFee: 'Opłata BTP',
    ownerPayout: 'Wypłata dla właściciela (netto)',
    details: 'Szczegóły',
    item: 'Pozycja',
    amount: 'Kwota',
    noCarsAssigned: 'Brak przypisanych aut',
    vehicleForm: 'Formularz Pojazdu',
    make: 'Marka',
    model: 'Model',
    color: 'Kolor',
    plate: 'Tablica rej.',
    registration: 'Rejestracja',
    productionYear: 'Rok Produkcji',
    serviceDate: 'Data Serwisu',
    insuranceDate: 'Data Ubezpieczenia',
    policyNumber: 'Nr polisy',
    insurerName: 'Nazwa ubezpieczalni',
    inspectionDate: 'Data Przeglądu',
    inspectionValidTo: 'Przegląd do',
    insuranceValidTo: 'Ubezpieczenie do',
    lastService: 'Ostatni serwis',
    wrapType: 'Oklejenie',
    deposit: 'Kaucja (PLN)',
    rentCost: 'Koszt najmu (PLN)',
    odometer: 'Przebieg (km)',
    previousOdometer: 'Poprzedni zapisany przebieg (km)',
    fuelType: 'Rodzaj paliwa',
    sideNumber: 'Nr boczny',
    companyCar: 'Auto firmowe?',
    fuelCard: 'Karta Paliwowa',
    branch: 'Oddział',
  },
  fleetDetails: {
    protocolComparison: 'Porównanie Protokołów',
    matching: 'Zgodne',
    different: 'Różne',
    missingInOther: 'Brak w drugim',
    carManagement: 'Zarządzanie Autem',
    licenses: 'Licencje',
    rentProtocol: 'Protokół Najmu',
    endRent: 'Zakończenie Najmu',
    endRentProtocol: 'Protokół Zakończenia Najmu',
    service: 'Serwis',
    crash: 'Szkoda',
    quickActions: 'Szybkie Akcje',
    backToList: 'Powrót do listy',
    compareProtocols: 'Porównaj Protokoły',
    carHistoryManagement: 'Zarządzanie Historią Auta',
    assignLicenses: 'Przypisywanie licencji',
    licenseNumber: 'Numer licencji',
    licenseExcerptNumber: 'Numer Wypisu Licencji',
    city: 'Miasto',
    saveLicense: 'Zapisz Licencję',
    noLicenses: 'Brak zapisanych licencji',
    saveRentProtocol: 'Zapisz protokół najmu',
    saveEndProtocol: 'Zapisz protokół zakończenia',
    saveService: 'Zapisz serwis',
    saveCrash: 'Zapisz szkodę',
    searchHistory: 'Wyszukaj w historii',
    allOk: '✅ WSZYSTKO OK!',
    sameState: 'Auto oddane w takim samym stanie',
    changesFound: 'ZNALEZIONO {count} ZMIAN W AUCIE',
    before: 'BYŁY:',
    after: 'JEST:',
    howToRead: 'JAK TO CZYTAĆ?',
    greenLabel: 'Zielone',
    greenMeans: '= Wszystko w porządku',
    redLabel: 'Czerwone',
    redMeans: '= Problem do wyjaśnienia',
    startDate: 'Data rozp.',
    collectedDeposit: 'Pobrana Kaucja',
    depositMethod: 'Metoda Pobrania Kaucji',
    handoverMileage: 'Przebieg przy wydaniu (km)',
  },
  driverFleet: {
    title: 'Flota Kierowców (auta prywatne)',
    active: 'Aktywne',
    pending: 'Oczekujące',
    archive: 'Archiwum',
    pendingApproval: 'Oczekujące na zatwierdzenie',
    archiveTitle: 'Archiwum - usunięte auta prywatne',
    restore: 'Przywróć',
    assignDriver: 'Przypisz kierowcę',
    assignDriverToVehicle: 'Przypisz kierowcę do pojazdu',
    vehicle: 'Pojazd',
    selectDriver: 'Wybierz kierowcę',
    driverNotFound: 'Nie znaleziono kierowcy',
    driverSearchHint: 'Wpisz imię, nazwisko lub email',
    driversInDb: 'W bazie',
    skip: 'Pomiń',
    assign: 'Przypisz',
    editVehicle: 'Edytuj pojazd',
  },
  crashes: {
    addingCrash: 'Dodawanie szkody',
    category: 'Kategoria',
    vehicleAndDriver: 'Pojazd i kierowca',
    insurer: 'Ubezpieczyciel',
    description: 'Opis',
    documents: 'Dokumenty',
    summary: 'Podsumowanie',
    step1Hint: 'Wybierz kategorię szkody oraz podstawowe dane identyfikacyjne.',
    step2Hint: 'Wskaż kierowcę oraz pojazd, którego dotyczy szkoda.',
    step3Hint: 'Dane ubezpieczyciela i numer polisy / szkody z jego strony.',
    step4Hint: 'Opisz okoliczności szkody — co, gdzie, jak.',
    step5Hint: 'Dodaj zdjęcia szkody, oświadczenia, protokoły policyjne. Krok opcjonalny.',
    step6Hint: 'Sprawdź dane przed zapisem. Te informacje zostaną wykorzystane do automatycznego wypełniania dokumentów.',
    crashDate: 'Data szkody',
    crashNumber: 'Numer szkody',
    vehicleOptional: 'Pojazd (opcjonalne)',
    vehicleOptionalHint: 'Pomiń, jeśli szkoda nie dotyczy konkretnego pojazdu',
    insurerData: 'Dane ubezpieczyciela',
    incidentDescription: 'Opis zdarzenia',
    files: 'Pliki (zdjęcia, PDF)',
    vehicle: 'Pojazd',
    attachments: 'Załączniki',
    saveCrash: 'Zapisz szkodę',
    company: 'Firmowe',
    cessions: 'Cesje',
    external: 'Szkody zewnętrzne',
    rentCalculator: 'Kalkulator najmu',
    rentCalculatorTitle: 'Kalkulator najmu pojazdu zastępczego',
    companyCrashes: 'Szkody firmowe',
    externalCrashes: 'Szkody zewnętrzne',
    downloadFiles: 'Pobierz pliki',
    registrationNumber: 'Nr rejestracyjny',
    dailyRate: 'Stawka za dobę (PLN)',
    vehicleCount: 'Liczba pojazdów',
    dayCount: 'Liczba dni',
    amountPerVehicle: 'Kwota za pojazd',
    clear: 'Wyczyść',
    copy: 'Skopiuj',
    copySummary: 'Skopiuj podsumowanie',
    saveCalculation: 'Zapisz obliczenie',
    calculationHistory: 'Historia obliczeń',
    searchByPlateOrCrash: 'Szukaj po rejestracji / szkodzie',
    savedDate: 'Data zapisu',
    plateOrCrashNo: 'Nr rej. / Nr szkody',
    period: 'Okres',
    days: 'Dni',
    rate: 'Stawka',
    vehicles: 'Pojazdy',
    total: 'Suma',
    editCrash: 'Edycja Szkody',
    crashStatus: 'Status szkody',
    addNewFiles: 'Dodaj nowe pliki',
    newFilesPreview: 'Podgląd nowych plików',
    existingFiles: 'Istniejące pliki',
    file: 'Plik',
    descriptionPlaceholder: 'Np. Kolizja na skrzyżowaniu ul. Marszałkowskiej z Al. Jerozolimskimi. Pojazd osobowy uderzył w tył auta przy zmianie pasa…',
  },
  crashDetails: {
    title: 'Historia szkód pojazdu',
    addHistory: 'Dodaj historię',
    crashId: 'ID Szkody',
    crashDescription: 'Opis szkody',
    visibleToDriver: 'Widoczne dla kierowcy',
    visibleToDriverHint: 'Zaznacz, jeśli kierowca ma widzieć tę notatkę',
    files: 'Pliki',
    searchHistory: 'Szukaj w historii szkód',
    refreshData: 'Odśwież dane',
    crashHistory: 'Historia szkód',
    details: 'Szczegóły',
    noCrashHistory: 'Brak historii szkód dla tego pojazdu',
    crashDetails: 'Szczegóły szkody',
  },
  fuelCards: {
    title: 'Karty Paliwowe',
    fuelCard: 'Karta Paliwowa',
    number: 'Numer',
    provider: 'Dostawca',
  },
  carRent: {
    title: 'Wynajem Auta',
    rentalForm: 'Formularz Najmu',
    amount: 'Kwota',
  },
  uploader: {
    importSettlements: 'Import rozliczeń',
    importRental: 'Import wynajmu',
    application: 'Aplikacja',
    template: 'Szablon',
    settlementFile: 'Plik rozliczeniowy',
    settlementName: 'Nazwa rozliczenia',
    import: 'Importuj',
  },
  auditLogs: {
    title: 'Logi Zdarzeń',
    exportCsv: 'Eksportuj CSV',
    searchPlaceholder: 'Szukaj...',
    action: 'Akcja',
    role: 'Rola',
    from: 'Od',
    to: 'Do',
    clear: 'Wyczyść',
    noEntries: 'Brak wpisów',
    dateTime: 'Data/Czas',
    user: 'Użytkownik',
    target: 'Obiekt',
    details: 'Szczegóły',
    endpoint: 'Endpoint',
    targetType: 'Typ obiektu',
    targetId: 'ID obiektu',
    targetDisplay: 'Dotyczy',
    ip: 'IP',
  },
  departaments: {
    title: 'Departamenty',
    form: 'Formularz',
  },
  documentFiller: {
    selectDocument: 'Wybierz dokument',
    analyzeDocument: 'Analizuj dokument',
    generateDocument: 'Generuj dokument',
    generatedDocument: 'Wygenerowany dokument',
    downloadDocument: 'Pobierz dokument',
  },
  importHistory: {
    title: 'Historia Importu',
    weekFrom: 'Od tygodnia',
    weekTo: 'Do tygodnia',
    reImportSkipped: 'Reimportuj pominięte',
    showSkipped: 'Pokaż pominięte',
    undoImport: 'Cofnij import',
    importCancelled: 'Import anulowany',
    downloadFile: 'Pobierz plik',
  },
  payoutConfig: {
    title: 'Konfiguracja Wypłat',
    zusRatesByType: 'Stawki ZUS według typu',
    total: 'Razem',
    sickLeave: 'Chorobowe',
    social: 'Społeczne',
    pitAdvance: 'Zaliczka PIT',
    health: 'Zdrowotne',
    settlementThreshold: 'Próg rozliczenia',
    minSettlementAmount: 'Minimalna kwota rozliczenia',
    zusType: 'Typ ZUS',
    zusTotal: 'Suma ZUS',
    suggested: 'Sugerowane',
    maxContract: 'Max Zleceniówka',
    receiptConfig: 'Konfiguracja Rachunku',
    itemDescription: 'Opis pozycji',
    paymentDays: 'Dni na zapłatę',
    issuePlace: 'Miejsce wystawienia',
    additionalNotes: 'Dodatkowe uwagi',
    minSettlementHint: 'Minimalna kwota do wygenerowania rozliczenia (domyślnie 201 PLN)',
  },
  pointsDrivers: {
    title: 'Salda Kierowców',
    searchDriver: 'Szukaj kierowcy',
    pointsCorrection: 'Korekta punktów',
    saveCorrection: 'Zapisz korektę',
    pointsHistory: 'Historia punktów',
  },
  pointsReferrals: {
    title: 'Polecenia',
    awarded: 'Przyznane',
    pendingStatus: 'Oczekujące',
  },
  pointsReviews: {
    title: 'Opinie',
    reviewLink: 'Link do opinii',
    screenshotPreview: 'Podgląd zrzutu ekranu',
    openInNewTab: 'Otwórz w nowej karcie',
    rejectReview: 'Odrzuć opinię',
  },
  pointsRewardOrders: {
    title: 'Zamówienia Nagród',
    issued: 'Wydane',
  },
  pointsSettings: {
    pointRates: 'Stawki Punktów',
    referralConditions: 'Warunki polecenia',
    addCondition: 'Dodaj warunek',
    saveConfig: 'Zapisz konfigurację',
    rewardCatalog: 'Katalog Nagród',
    regulation: 'Regulamin',
    noRegulation: 'Brak regulaminu',
    uploadRegulation: 'Wgraj regulamin',
    editReward: 'Edytuj nagrodę',
    newReward: 'Nowa nagroda',
  },
  skippedImport: {
    title: 'Pominięte Importy',
    assign: 'Przypisz',
    selectDriver: 'Wybierz kierowcę',
    searchDriver: 'Szukaj kierowcy',
    noDriversFound: 'Nie znaleziono kierowców',
  },
  subFleet: {
    title: 'Podfloty',
    subtitle: 'Zarządzanie podflotami i rozliczenia z właścicielami',
    newSubFleet: 'Nowa podflota',
    editSubFleet: 'Edytuj podflotę',
    owner: 'Właściciel',
    fees: 'Opłaty',
    settlement: 'Rozliczenie',
    carsAndDrivers: 'Auta i Kierowcy',
    totalRent: 'Całkowity najem',
    btpCommission: 'Prowizja BTP',
    ownerPayout: 'Wypłata dla właściciela',
    item: 'Pozycja',
    amount: 'Kwota',
  },
  systemSettings: {
    tabletsTitle: 'Tablety do podpisu',
    tabletsHint: 'Urządzenia sparowane do podpisywania wypłat i raportu kasowego. Prośba o podpis trafia na tablet, który odezwał się ostatnio.',
    tabletsEmpty: 'Nie ma sparowanych tabletów. Sparujesz je na Wypłatach lub w Raporcie kasowym.',
    tabletName: 'Nazwa',
    tabletPaired: 'Sparowany',
    tabletLastSeen: 'Ostatnio widziany',
    tabletState: 'Stan',
    tabletActive: 'Odbiera podpisy',
    tabletSilent: 'Milczy — nie odbierze podpisu',
    tabletNeverSeen: 'nigdy się nie odezwał',
    tabletRemove: 'Usuń z listy',
    tabletRemoveConfirm: 'Usunąć „{name}" z listy urządzeń? Tablet będzie trzeba sparować od nowa.',
    tabletRemoved: 'Urządzenie usunięte',
    tabletRemoveError: 'Nie udało się usunąć urządzenia',
    title: 'Ustawienia systemu',
    subtitle: 'Globalne ustawienia aplikacji',
    systemLogo: 'Logo systemu',
    logoHint: 'Wgraj logo widoczne w całym panelu',
    superadminOnly: 'Tylko superadmin',
    driverTerms: 'Regulamin aplikacji kierowcy',
    driverTermsHint: 'Wgraj plik PDF z regulaminem — kierowcy muszą go zaakceptować przy logowaniu do aplikacji',
    driverTermsNone: 'Regulamin nie został jeszcze wgrany.',
    driverTermsPick: 'Wybierz plik PDF',
    driverTermsUpload: 'Wgraj regulamin',
    driverTermsUploaded: 'Regulamin został wgrany.',
    driverTermsUploadError: 'Nie udało się wgrać regulaminu.',
    driverTermsPreviewError: 'Nie udało się otworzyć podglądu regulaminu.',
    driverTermsPdfOnly: 'Regulamin musi być plikiem PDF.',
    driverTermsReacceptNote: 'Po wgraniu nowego pliku wszyscy kierowcy będą musieli ponownie zaakceptować regulamin przy najbliższym logowaniu.',
    driverTermsAcceptances: 'Historia akceptacji',
    driverTermsAccepted: 'Zaakceptowali',
    driverTermsMissing: 'Nie zaakceptowali',
    driverTermsCurrentVersion: 'Aktualna wersja',
    driverTermsColDriver: 'Kierowca',
    driverTermsColVersion: 'Wersja',
    driverTermsColDate: 'Data akceptacji',
    driverTermsColIp: 'Adres IP',
    driverTermsColPhone: 'Telefon',
    driverTermsNoMissing: 'Wszyscy aktywni kierowcy zaakceptowali aktualną wersję regulaminu.',
    driverTermsAcceptancesError: 'Nie udało się pobrać historii akceptacji.',
    noLogo: 'Brak logo',
    unsavedPreview: 'Podgląd (niezapisane)',
    currentLogo: 'Aktualne logo',
    uploadLogo: 'Wgraj logo',
    uploadHint: 'Przeciągnij plik lub kliknij, aby wybrać (PNG, JPG, SVG)',
    removeLogo: 'Usuń logo',
    balancePln: 'Saldo (zł)',
    sendingActive: 'Wysyłka aktywna',
    recipientEmail: 'Adres e-mail odbiorcy',
    saveBalance: 'Zapisz saldo',
    fetchCurrent: 'Pobierz aktualne',
    cashReportTitle: 'Raport kasowy — automatyczna wysyłka miesięczna',
    cashReportSubtitle: '1. dnia każdego miesiąca o 02:00 wysyłany jest raport za poprzedni miesiąc (PDF + CSV) na podany adres e-mail.',
    emailExample: 'ksiegowosc@firma.pl',
  },
  uploaderTemplates: {
    title: 'Wzory Importu',
    addFileCreateTemplate: 'Dodaj plik i utwórz szablon',
    customVariables: 'Zmienne własne',
    addCustomVariable: 'Dodaj zmienną',
    onlyOneCompany: 'Na ten moment może istnieć tylko jedna firma',
  },
  wiki: {
    backToWiki: 'Wróć do Wiki',
    newTab: 'Nowa karta',
    tryAgain: 'Spróbuj ponownie',
    previewNotAvailable: 'Podgląd niedostępny',
    openInNewTab: 'Otwórz w nowej karcie',
    attachments: 'Załączniki',
    noAttachments: 'Brak załączników',
    addAttachment: 'Dodaj załącznik',
    addDescription: 'Dodaj opis',
    editDescription: 'Edytuj opis',
    descriptionPlaceholder: 'Opis / instrukcja do pliku (np. jak korzystać, czego dotyczy)…',
    noPreviewForType: 'Brak podglądu dla tego typu pliku',
    open: 'Otwórz',
    confirmation: 'Potwierdzenie',
    confirmDeleteArticle: 'Czy na pewno usunąć artykuł',
    attachmentsWillBeDeleted: 'Załączniki zostaną usunięte.',
    searchArticle: 'Szukaj artykułu...',
    addArticle: 'Dodaj artykuł',
    newSection: 'Nowa sekcja',
    deleteSection: 'Usuń sekcję',
    noArticles: 'Brak artykułów',
    noArticlesHint: 'Dodaj pierwszy artykuł, aby rozpocząć',
    deleteArticle: 'Usuń artykuł',
    newArticle: 'Nowy artykuł',
    articleTitle: 'Tytuł artykułu',
    articleTitlePlaceholder: 'np. Jak dodać kierowcę',
    section: 'Sekcja',
    addSectionFirst: 'Najpierw dodaj sekcję',
    changeFile: 'Zmień plik',
    selectPdf: 'Wybierz PDF',
    sectionName: 'Nazwa sekcji',
    sectionNamePlaceholder: 'np. Onboarding',
    sectionId: 'ID sekcji',
    icon: 'Ikona',
    confirmDeleteMsg: 'Czy na pewno usunąć',
    sectionDeleteWarning: 'Wszystkie artykuły w tej sekcji również zostaną usunięte.',
  },
  wykazKierowcy: {
    cityBranch: 'Miasto / Oddział',
    active: 'Aktywni',
    pending: 'Oczekujący',
    delisted: 'Wykreśleni',
    archive: 'Archiwum',
    delistFromRegistry: 'Wykreśl z wykazu',
    pendingApproval: 'Oczekujący na zatwierdzenie',
    delistedFromRegistry: 'Wykreśleni z wykazu',
    driverArchive: 'Archiwum kierowców',
    restore: 'Przywróć',
    editDriver: 'Edytuj kierowcę',
    addNewDriver: 'Dodaj nowego kierowcę',
    lp: 'Lp.',
    fullName: 'Imię i nazwisko',
    drivingLicense: 'Prawo jazdy (seria/nr)',
    medicalCertNumber: 'Nr orzeczenia lekarskiego',
    medicalExpiry: 'Ważność orzeczenia lekarskiego',
    psychCertNumber: 'Nr orzeczenia psychologicznego',
    psychExpiry: 'Ważność orzeczenia psychologicznego',
    criminalRecord: 'Zaświadczenie o niekaralności',
    licenseType: 'Typ licencji',
    vehiclePlate: 'Nr rejestracyjny pojazdu',
    medicalCert: 'Orzeczenie lekarskie',
    psychCert: 'Orzeczenie psychologiczne',
    vehicle: 'Pojazd',
    addedBy: 'Dodał',
    approvedBy: 'Zatwierdził',
    rejectionReason: 'Powód odrzucenia',
    delistedOn: 'Data wykreślenia',
    delistedByPerson: 'Wykreślił',
    rejectEntry: 'Odrzuć wpis',
    delistTitle: 'Wykreślenie z wykazu',
    delistDate: 'Data wykreślenia',
    saveDelist: 'Zapisz wykreślenie',
  },
  wykaz: {
    vehicles: {
      title: 'Wykaz pojazdów',
      addButton: 'Dodaj pojazd',
    },
    drivers: {
      title: 'Wykaz kierowców',
      addButton: 'Dodaj kierowcę',
    },
  },
  wykazPojazdy: {
    cityBranch: 'Miasto / Oddział',
    activeTab: 'Aktywne',
    pendingTab: 'Oczekujące',
    archiveTab: 'Archiwum',
    pendingApproval: 'Oczekujące na zatwierdzenie',
    vehicleArchive: 'Archiwum pojazdów',
    restore: 'Przywróć',
    editVehicle: 'Edytuj pojazd',
    addNewVehicle: 'Dodaj nowy pojazd',
    rejectEntry: 'Odrzuć wpis',
    vehicleLabel: 'Pojazd',
    rejectionReason: 'Powód odrzucenia',
  },
  uber: {
    integrationTitle: 'Integracja Uber',
    integrationHint: 'Klucze API do pobierania rozliczeń dziennych z Ubera (Supplier Platform)',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    secretPlaceholder: 'Wpisz nowy secret (pozostaw puste, aby nie zmieniać)',
    testConnection: 'Testuj połączenie',
    saveCredentials: 'Zapisz klucze',
    removeCredentials: 'Usuń integrację',
    notConfigured: 'Brak konfiguracji',
    configured: 'Skonfigurowano',
    lastTest: 'Ostatni test',
    testOk: 'Połączenie działa',
    testFailed: 'Błąd połączenia',
    externalCompanyId: 'Org ID w Uberze',
    confirmRemove: 'Usunąć integrację Uber?',
  },
  uberDailyPayouts: {
    title: 'Wypłaty dzienne (Uber)',
    subtitle: 'Mini-rozliczenie dzienne z Uber API: tree breakdown → formuła → wypłata',
    unmappedWarning: 'Wykryto nieznane kategorie Ubera — niektóre kwoty mogą być pominięte',
  },
  boltSync: {
    title: 'Synchronizacja kierowców z Boltem',
    subtitle: 'Automatyczne dopasowanie UUID Bolta do Waszych kierowców',
    loadPreview: 'Załaduj podgląd',
    applyChanges: 'Zastosuj zmiany',
    applying: 'Stosuję...',
    totalBolt: 'Kierowców w Bolcie',
    alreadyLinked: 'Już powiązanych',
    autoAssignTitle: 'Automatyczne dopasowania',
    autoAssignHint: 'Wysoka pewność dopasowania (≥80 pkt). Zaznacz żeby zaakceptować.',
    suggestionsTitle: 'Sugerowane dopasowania',
    suggestionsHint: 'Dopasowania niepewne (40-79 pkt). Potwierdź dla każdego indywidualnie.',
    idConflictsTitle: 'Konflikt ID',
    idConflictsHint: 'Wszystkie dane się zgadzają, ale Bolt zwrócił inne UUID. Podmienić?',
    toCreateTitle: 'Nowi kierowcy (z Bolta, nie ma u nas)',
    toCreateHint: 'Te osoby są w Bolcie ale nie mają konta u nas. Utworzyć automatycznie?',
    ourDriver: 'Nasz kierowca',
    boltDriver: 'Kierowca w Bolcie',
    score: 'Punkty',
    reasons: 'Dopasowanie po',
    currentBoltId: 'Obecny Bolt ID',
    newBoltId: 'Nowy Bolt ID',
    acceptAll: 'Zaznacz wszystkie',
    rejectAll: 'Odznacz wszystkie',
    cooperationTypeDefault: 'Domyślny typ współpracy dla nowych',
    noMatches: 'Brak automatycznych dopasowań',
    noSuggestions: 'Brak sugestii',
    noConflicts: 'Brak konfliktów ID',
    noToCreate: 'Wszyscy kierowcy z Bolta mają już konto',
    applyResult: 'Przypisano: {assigned}, konflikty: {conflicts}, utworzono: {created}, błędy: {errors}',
    noIntegration: 'Najpierw skonfiguruj integrację Bolt w Ustawieniach systemu',
    runSync: 'Uruchom synchronizację',
  },
  bolt: {
    integrationTitle: 'Integracja Bolt',
    integrationHint: 'Klucze API do pobierania rozliczeń dziennych z Bolta',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    clientIdCurrent: 'Aktualny Client ID',
    secretPlaceholder: 'Wpisz nowy secret (pozostaw puste, aby nie zmieniać)',
    testConnection: 'Testuj połączenie',
    saveCredentials: 'Zapisz klucze',
    removeCredentials: 'Usuń integrację',
    notConfigured: 'Brak konfiguracji',
    configured: 'Skonfigurowano',
    lastTest: 'Ostatni test',
    testOk: 'Połączenie działa',
    testFailed: 'Błąd połączenia',
    externalCompanyId: 'ID firmy w Bolcie',
    confirmRemove: 'Usunąć integrację Bolt?',
  },
  selfService: {
    title: 'Wypłaty BLIK',
    queueTitle: 'Wypłaty do akceptacji',
    historyTitle: 'Historia wypłat BLIK',
    empty: 'Brak wypłat oczekujących na akceptację',
    driver: 'Kierowca',
    phone: 'Telefon',
    accountNo: 'Konto',
    requestedAmount: 'Żądana kwota',
    availableAtRequest: 'Dostępne w momencie żądania',
    fee: 'Opłata',
    status: 'Status',
    createdAt: 'Utworzone',
    approve: 'Akceptuj',
    reject: 'Odrzuć',
    rejectReason: 'Powód odrzucenia (opcjonalnie)',
    confirmApprove: 'Zaakceptować wypłatę?',
    confirmReject: 'Odrzucić wypłatę?',
    approved: 'Zaakceptowano',
    rejected: 'Odrzucono',
    config: 'Konfiguracja wypłat BLIK',
    enabled: 'Włącz wypłaty BLIK',
    percentLimit: 'Limit procentowy (%)',
    autoApproveThreshold: 'Próg auto-akceptacji (zł)',
    maxPerDay: 'Maks. wypłat dziennie',
    startHour: 'Godzina startu (0-23)',
    endHour: 'Godzina końca (0-23)',
    provider: 'Dostawca płatności',
    providerStub: 'STUB (test)',
    providerAutopay: 'Autopay (BLIK)',
    providerTpay: 'Tpay (BLIK)',
    statuses: {
      REQUESTED: 'Zgłoszone',
      AUTO_APPROVED: 'Auto-zaakceptowane',
      NEEDS_APPROVAL: 'Czeka na admina',
      APPROVED: 'Zaakceptowane',
      REJECTED: 'Odrzucone',
      PROCESSING: 'W trakcie',
      PAID: 'Wypłacone',
      FAILED: 'Błąd',
    },
  },
  dailyPayouts: {
    title: 'Wypłaty dzienne (Bolt)',
    subtitle: 'Mini-rozliczenie dzienne: kursy z Bolta → wypłata tego samego dnia',
    date: 'Dzień',
    refresh: 'Odśwież',
    generate: 'Wygeneruj przelewy',
    generating: 'Generuję...',
    alreadyGenerated: 'Już wygenerowane',
    noData: 'Brak kursów dla wybranego dnia',
    totalOrders: 'Kursów łącznie',
    matchedDrivers: 'Dopasowanych kierowców',
    unmatchedDrivers: 'Niedopasowanych',
    unmatchedWarning: 'Nie wszyscy kierowcy z Bolta są w bazie',
    unmatchedDetails: 'Niedopasowani kierowcy',
    driver: 'Kierowca',
    ordersCount: 'Kursów',
    grossTotal: 'Brutto',
    grossApp: 'Brutto (aplikacja)',
    grossCash: 'Brutto (gotówka)',
    cashCollected: 'Pobrana gotówka',
    tips: 'Napiwki',
    commission: 'Prowizja Bolt',
    netEarnings: 'Netto Bolt',
    calculatedAmount: 'Wyliczona kwota',
    fee: 'Opłata',
    finalAmount: 'Do wypłaty',
    status: 'Status',
    statusReady: 'Gotowe',
    statusAlreadyPaid: 'Wypłacono',
    statusUnmatched: 'Kierowca niedopasowany',
    statusFormulaError: 'Błąd formuły',
    statusNoAmount: 'Brak kwoty',
    generateSuccess: 'Utworzono {count} przelewów',
    generatePartial: '{created} utworzonych, {skipped} pominiętych',
    formulaErrorTooltip: 'Brak MathEq dla typu współpracy lub błąd formuły',
    configureBoltFirst: 'Skonfiguruj integrację Bolt w Ustawieniach systemu',
    freeNowComingSoon: 'Integracja FreeNow w planach — zrobimy później. Na razie możesz importować CSV z portalu FreeNow przez Importer.',
    integrationHint: 'Wygenerowane zaliczki trafią do najbliższego koszyka przelewów z zakładki Wypłaty.',
    markPaid: 'Oznacz jako wypłacone',
    recentPayouts: 'Ostatnie wypłaty dzienne',
    paid: 'Wypłacone',
    pending: 'Oczekujące',
  },
}
